"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("../../components/utils/helpers");
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    root: {
      '&:hover': {
        borderBottom: isHighContrast ? "1px solid ".concat(_helpers.agentDeveloperUtils.getPrimaryColor(300)) : "1px solid ".concat(_helpers.agentDeveloperUtils.getPrimaryColor(450)),
        paddingBottom: '0px'
      },
      fontSize: isFontBigger ? '23px' : '20px',
      fontWeight: 200,
      textDecoration: 'none !important'
    }
  };
};
exports.default = _default;